import { Form, Formik } from "formik";
import React, { useEffect, useContext } from "react";
import request from "../../services/request";
import * as yup from "yup";
import { useTranslation } from "react-i18next"; /* Added Line */
import moment from "moment";
import { ThemeContext } from '../../../context/ThemeContext';

var today = new Date();
var threeMonthsAgo = new Date();
threeMonthsAgo.setMonth(today.getMonth()-3);

export default function Filters(props) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [t, i18n] = useTranslation(); /* Added Line */
  useEffect(() => {
    if (props.configPointUrl) {
      fetchConfigData();
    }
  }, [props.refreshConfig || props.configParameterValue || null]);

  const onSubmit = (values, { setSubmitting }) => {
    const { setFilters, setRefreshList, refreshList, setColumns, columns } =
      props;

    if (setColumns) {
      let tempColumns = columns.map((c) => {
        if (values.filterColumns.findIndex((fc) => fc == c.filterId) != -1) {
          return {
            ...c,
            hidden: true,
          };
        } else {
          return {
            ...c,
          };
        }
      });
      setColumns(tempColumns);
    }

    let tempFilters = [];
    Object.keys(values).forEach((k) => {
      let findedItem = (props.children.length ? props.children : [props.children]).find(c => c && c.props.name == k);
      if (values[k] && findedItem) {
        tempFilters.push({
          fieldName: findedItem?.props.fieldName || k,
          value: values[k],
          oper: findedItem?.props.oper || "CONTAINS",
          joinEntity: findedItem?.props.joinEntity || null,
          type: findedItem?.props.type || null,
        });
      }
    });
    setFilters(tempFilters);
    setRefreshList(!refreshList);

    setTimeout(() => {
      setSubmitting(false);
    }, 400);
  };

  const fetchConfigData = () => {
    request({
      url: props.configPointUrl,
      method: props.configReqType || "GET",
      data: props.configReqType
        ? {
            body: {
              [props.entityFetchId]: props.entityId || undefined,
              [props.configParameterName]:
                props.configParameterValue || undefined,
            },
          }
        : {},
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        props.setConfigData(response.body);
      }
    });
  };

  Date.prototype.rmDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
  };

  return (
    <div>
      <Formik
        initialValues={!props.ignoreInitialDates ? {
          acilisTarihiMin: threeMonthsAgo || null,
          acilisTarihiMax: today || null,
          kapanisTarihiMax: today || null
        } : {}}
        validationSchema={yup.object({})}
        onSubmit={onSubmit}
        enableReinitialize={false}
        key={"filtersForm"}
      >
        {({ setFieldValue, handleSubmit, isSubmitting, resetForm }) => {
          
          if( props.resetFilterFormRef)
            props.resetFilterFormRef(resetForm);

        return (
          <Form key={"filtersForm"}>
            <div className="row">{props.children}</div>
            {!props.hideFooterHr && <hr />}
            <div className="row">
              <div className="col-lg-12">
                <button
                  key={"submitButton"}
                  className="submit btn btn-primary btn-sm"
                  disabled={isSubmitting}
                  // onClick={handleSubmit}
                  type="submit"
                >
                  {t("sozlesmeler.filtrele")}
                </button>
                {
                  !props.hideResetButton &&
                  <button
                    key={"resetButton"}
                    className="submit btn btn-outline-info btn-sm ml-2"
                    onClick={
                      () => {
                        resetForm();
                        props.setResetButtonHandler(!props.resetButtonHandler);
                      }
                    }
                  >
                    {t("actionButtonGenerator.formuTemizle")}
                  </button>
                }
              </div>
            </div>
          </Form>
        )
        }
      }
      </Formik>
    </div>
  );
}